import { createAction } from '@reduxjs/toolkit';

export const fetchDecagonSignature = createAction(
    'FETCH_DECAGON_SIGNATURE::REQUEST',
);
export const fetchDecagonSignatureSuccess = createAction(
    'FETCH_DECAGON_SIGNATURE::SUCCESS',
);
export const fetchDecagonSignatureError = createAction(
    'FETCH_DECAGON_SIGNATURE::ERROR',
);
export const fetchDecagonSignatureReset = createAction(
    'FETCH_DECAGON_SIGNATURE::RESET',
);

export const loadDecagonSupportTool = createAction('LOAD_DECAGON_SUPPORT_TOOL');
export const loadDecagonSupportToolSuccess = createAction(
    'LOAD_DECAGON_SUPPORT_TOOL::SUCCESS',
);
export const loadDecagonSupportToolError = createAction(
    'LOAD_DECAGON_SUPPORT_TOOL::ERROR',
);
